<template>
    <v-card class="mb-2" :class="{'soft-shadow pa-3': !flat}" :flat="flat">
        <v-list-item :disabled="disabled" class="settings-item rounded" :class="{'surface': pcOnly && !disabled}" v-ripple="{class: 'soft-ripple'}" @click="!isSwitch ? openDialog = true : value = !value">
            <v-list-item-icon :class="color.split(' ')[0] + '--text'">
                <v-icon v-if="icon" :color="color">{{icon}}</v-icon>
                <slot v-else name="icon" />
            </v-list-item-icon>

            <v-list-item-content class="d-flex flex-column align-start" :class="{'flex-column-reverse': !isSwitch && !isTextarea}">
                <v-list-item-title class="text-right align-self-start" :class="{'ltr-dir': ltr}">
                    <span v-if="isSwitch || isTextarea">{{title}}</span>
                    <strong v-else-if="isColorPicker && valueText" :style="`color: ${valueText === '#FFFFFF' ? '#d0d0d0' : valueText}`">{{valueText}}</strong>
                    <span v-else :class="{'muted--text medium-text': !valueText}">{{valueText ? valueText : 'غير محدد'}}</span>

                </v-list-item-title>
                <v-list-item-subtitle class="text--text nowrap">
                    <span v-if="falseSubtitle && isSwitch && !value">{{falseSubtitle}}</span>
                    <span v-else-if="isSwitch || isTextarea">{{subtitle}}</span>
                    <span v-else>{{title}}</span>
                </v-list-item-subtitle>
            </v-list-item-content>

            <div v-if="isSwitch" @click.stop @touchstart.stop @mousedown.stop>
                <v-switch :color="color" height="30" :loading="loading" v-model="value" @click.stop @touchstart.stop @mousedown.stop></v-switch>
            </div>
            <v-list-item-icon v-else>
                <v-icon color="grey lighten-1" size="21">{{disabled ? '' : 'mdi-pencil'}}</v-icon>
            </v-list-item-icon>

            <v-dialog v-if="!isSwitch" v-model="openDialog" :max-width="isTextarea ? 600 : 400" overlay-color="#000" overlay-opacity="0.75" persistent>
                <v-card class="px-2 py-1">
                    <v-card-title class="mb-2">تعديل {{title}}</v-card-title>
                    <v-card-subtitle class="nowrap">{{subtitle}}</v-card-subtitle>
                    <v-card-text>
                        <slot name="body-top" />
                        <form @submit.prevent="!isTextarea ?  updateSettings() : ''">
                            <v-select v-if="select" :label="title" :disabled="loading" :loading="loading" :items="selectItems" v-model="value">
                                <template v-slot:item="{item, on, attrs}">
                                    <v-list-item v-on="on" v-bind="attrs">
                                        <v-list-item-icon class="me-3">
                                            <v-icon v-if="item.icon" :color="value === item.value ? 'primary' : (item.color || 'strong-text')">{{item.icon}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>{{item.text}}</v-list-item-title>
                                        <v-list-item-subtitle>{{item.subtitle}}</v-list-item-subtitle>
                                    </v-list-item>
                                </template>
                            </v-select>
                            <v-color-picker v-else-if="isColorPicker" v-model="value" show-swatches width="350px" mode="hexa" hide-mode-switch></v-color-picker>
                            <template v-else>
                                <v-text-field v-if="!isTextarea" autofocus hide-details :type="number ? 'number' : 'text'" :color="color || 'primary'" :label="label ? label : title" :placeholder="placeholder ? placeholder : undefined" :disabled="loading" :loading="loading" v-model="value" />
                                <v-textarea v-else outlined autofocus auto-grow multi-line rows="3" hide-details no-resize :color="color || 'primary'" :label="label ? label : title" :placeholder="placeholder ? placeholder : undefined" :disabled="loading" :loading="loading" v-model="value" />
                            </template>
                        </form>
                    </v-card-text>

                    <v-card-actions class="px-3 py-2">
                        <v-spacer></v-spacer>
                        <v-btn color="muted" text @click="openDialog = false">إخفاء</v-btn>
                        <v-btn color="primary darken-1" class="px-6" :loading="loading" :disabled="loading" text @click="updateSettings">تأكيد</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-list-item>
    </v-card>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        name: { },
        icon: {},
        data: {type: Object},
        title: { type: String },
        subtitle: { type: String },
        falseSubtitle: { type: String },
        isSwitch: {type: Boolean, default: false},
        isTextarea: {type: Boolean, default: false},
        isColorPicker: {type: Boolean, default: false},
        eventAction: {type: Boolean, default: false},
        number: {type: Boolean, default: false,},
        label: {type: String, default: ''},
        color: {type: String, default: 'muted'},
        placeholder: {type: String, default: ''},
        prefix: {type: String},
        disabled: {type: Boolean, default: false},
        ltr: {type: Boolean, default: false},
        nullable: {type: Boolean, default: false},

        select: {type: Boolean, default: false},
        selectItems: {},

        flat: {type: Boolean, default: false},

        vuexAction: {default: 'updateStoreSettings'},
    },
    data(){
        return {
            value: '',
            loading: false,
            openDialog: false,
        }
    },
    computed: {
        valueText(){
            let value = this.savedValue;
            if (this.prefix){
                value = this.prefix + value;
            }
            if (this.select){
                let item = this.selectItems.find(s=>{
                    return s.value === value;
                });
                return item ? item.text : value;
            }
            return value;
        },
        savedValue(){
            return this.data[this.name];
        },
        ...GlobalComputed
    },
    watch: {
        data(){
            this.syncData();
        },
        value(){
            if (this.isSwitch){
                this.updateSettings();
            }
        },
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {

        updateSettings(){
            if (this.value !== this.savedValue){

                if (!this.loading){
                    if (this.value || this.value === 0 || this.isSwitch || this.nullable){
                        if (this.eventAction){
                            this.$emit('change', this.value);
                            this.showMsg("تم حفظ التغييرات بنجاح", 'success', false, false, 2000);
                            if (this.loading){
                                this.loading = false;
                            }
                            if (this.openDialog){
                                this.openDialog = false;
                            }
                        }else{

                            this.loading = true;

                            this.updateSettingsAction().then(response=>{
                                this.showMsg("تم حفظ التغييرات بنجاح", 'success', false, false, 2000);
                                this.loading = false;
                                this.$emit('sync', response.data.data);
                                if (this.openDialog){
                                    this.openDialog = false;
                                }
                            }).catch((e)=>{
                                if (e && e.response && e.response.status === 422){
                                    const errors = e.response.data.errors;
                                    this.showMsg(errors[Object.keys(errors)[0]][0]);
                                }else{
                                    this.showMsg('حدثت مشكلة أثناء الحفظ');
                                }
                                this.loading = false;
                                this.syncData();
                            })
                        }

                    }else{
                        this.showMsg('لا يمكنك ترك الحقل فارغاً');
                    }
                }

            }else{
                if (this.openDialog){
                    this.openDialog = false;
                }
            }
        },
        updateSettingsAction(){
            let data = {};
            data[this.name] = this.value;
            return this.$store.dispatch(this.vuexAction, {data});
        },
        syncData(){
            this.value = this.savedValue;
        },
        ...GlobalMethods
    },
    mounted(){
        this.syncData();
    }
}
</script>
<style lang="scss" scoped>
.settings-item{
}
</style>
<style lang="scss">
    .v-list-item--link:before{
        &:active, &:focus{
            opacity: 0!important;
        }
    }
    input[type="number"]{
        -moz-appearance: textfield;
        /* Chrome, Safari, Edge, Opera */
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    }
</style>
